import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import CardDialog from '@/components/dialogs/CardDialog.vue'
import { postNativeMessage, STORE_LINKS } from '@/helpers/mobile'
import { useServiceStore } from '@/store/service'
import { computed, inject } from 'vue'


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'MobileWrapperVersionDialog'
},
  __name: 'MobileWrapperVersionDialog',
  setup(__props) {



const isAndroid = inject<boolean>('isAndroid', false)

const { service } = useServiceStore()

const applicationStorePage = computed<string>(() =>
  isAndroid ? STORE_LINKS.ANDROID[service] : STORE_LINKS.IOS[service]
)

const applicationPageOpened = (): void => {
  /*
   * Send mesasge to the native app that the application page was opened and it will close the app
   * so that it's updated when opened again
   */
  const message = JSON.stringify({
    type: 'ukkopro_update_application'
  })
  postNativeMessage(message)
}

return (_ctx: any,_cache: any) => {
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!

  return (_openBlock(), _createBlock(CardDialog, {
    persistent: "",
    title: _ctx.$t('mobile.wrapper_version_dialog.title')
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_PrimaryButton, {
        class: "w-full",
        target: "_blank",
        rel: "noopener noreferrer",
        href: applicationStorePage.value,
        text: 
          _unref(isAndroid)
            ? _ctx.$t('mobile.wrapper_version_dialog.action_text_android')
            : _ctx.$t('mobile.wrapper_version_dialog.action_text_ios')
        ,
        onClick: applicationPageOpened
      }, null, 8, ["href", "text"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('mobile.wrapper_version_dialog.description')), 1)
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})